(function () {
  var revealObserver;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function reveal(root) {
    var items = root.querySelectorAll('[data-pt-reveal]:not([data-pt-reveal-ready])');

    if (reducedMotion.matches || !('IntersectionObserver' in window)) {
      items.forEach(function (item) {
        item.setAttribute('data-pt-reveal-ready', '');
        item.classList.add('is-visible');
      });
      return;
    }

    var isMobile = window.innerWidth <= 768;

    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        });
      }, {
        rootMargin: isMobile ? '250px 0px 100px 0px' : '0px 0px -8% 0px',
        threshold: isMobile ? 0.01 : 0.12
      });
    }

    items.forEach(function (item) {
      var rect = item.getBoundingClientRect();
      var buffer = isMobile ? window.innerHeight * 1.25 : window.innerHeight * 0.92;
      var isInitiallyVisible = rect.bottom > 0 && rect.top < buffer;

      /* The reveal stylesheet can finish loading before this deferred script.
         Mark items already in the viewport as visible before enabling their
         transition, otherwise they flash, fade out and then enter a second time. */
      if (isInitiallyVisible) item.classList.add('is-visible');
      item.setAttribute('data-pt-reveal-ready', '');
      if (!isInitiallyVisible) revealObserver.observe(item);
    });
  }

  function setupAmbientVideos(root) {
    var selector = [
      '.pt-ambient-video',
      '.pt-pdp-story-v2__gesture-media video',
      '.pt-pdp-ritual__media video'
    ].join(', ');

    var videos = (root || document).querySelectorAll(selector);

    videos.forEach(function (video) {
      if (!video || !video.isConnected || video.hasAttribute('data-pt-video-ready')) return;
      video.setAttribute('data-pt-video-ready', '');

      if (reducedMotion.matches) {
        video.remove();
        return;
      }

      /* Programmatic WebKit / iOS autoplay & controls enforcement */
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('x5-playsinline', '');
      video.setAttribute('disablepictureinpicture', '');
      video.setAttribute('disableremoteplayback', '');
      video.removeAttribute('controls');

      /* ONLY mark playing once the video actually advances beyond time 0.
         Never mark playing on loadeddata or readyState >= 2, because if autoplay
         is denied (e.g. iPad low power mode) a visible paused video shows
         WebKit's native play button! */
      function markPlaying() {
        if (video.isConnected && !video.classList.contains('is-playing')) {
          video.classList.add('is-playing');
        }
      }

      if (video.currentTime > 0 && !video.paused && !video.ended) {
        markPlaying();
      }

      video.addEventListener('playing', markPlaying);
      video.addEventListener('timeupdate', function onTime() {
        if (video.currentTime > 0.05) {
          markPlaying();
          video.removeEventListener('timeupdate', onTime);
        }
      });

      /* Attempt silent autoplay. If rejected (Low Power Mode), wipe the video tag
         so WebKit can NEVER render a native play button overlay. No scroll or
         touch listeners are attached. */
      function tryPlay() {
        if (!video.isConnected) return;
        video.muted = true;
        var playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.then(function () {
            markPlaying();
          }).catch(function () {
            video.remove();
          });
        }
      }

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!video.isConnected) {
              observer.unobserve(video);
              return;
            }
            if (entry.isIntersecting) {
              tryPlay();
            } else {
              if (!video.paused) {
                video.pause();
              }
            }
          });
        }, { threshold: 0.05 });
        observer.observe(video);
      } else {
        tryPlay();
      }
    });
  }

  function setupHero(root) {
    setupAmbientVideos(root);

    root.querySelectorAll('[data-section-type="pt-hero"]').forEach(function (hero) {
      var video = hero.querySelector('[data-pt-hero-video]');
      if (!video || video.hasAttribute('data-pt-video-ready')) return;
      video.setAttribute('data-pt-video-ready', '');

      if (reducedMotion.matches) {
        video.remove();
        return;
      }

      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;

      function markPlaying() {
        video.classList.add('is-playing');
      }

      function showAnimatedFallback() {
        if (!video.isConnected || !video.paused) return;

        // Safari can render an MP4 as an animated image even when it blocks
        // media autoplay in Low Power Mode. Other browsers keep the poster.
        var sources = video.querySelectorAll('source[type="video/mp4"]');
        var mobile = window.matchMedia('(max-width: 749px)').matches;
        var source = mobile && sources.length > 1 ? sources[1] : sources[0];
        var url = source && source.src;
        video.remove();
        if (!url) return;

        var image = document.createElement('img');
        image.className = 'pt-hero__animated';
        image.alt = '';
        image.setAttribute('aria-hidden', 'true');
        image.onload = function () { image.classList.add('is-ready'); };
        image.onerror = function () { image.remove(); };
        hero.querySelector('.pt-hero__sfondo').appendChild(image);
        image.src = url;
      }

      video.addEventListener('playing', markPlaying);
      try {
        var attempt = video.play();
        if (attempt && attempt.catch) attempt.catch(showAnimatedFallback);
      } catch (error) {
        showAnimatedFallback();
      }
    });
  }

  function setupTransparentHeader() {
    var headerContainer = document.querySelector('.template-index .header-container');
    if (!headerContainer) return;

    var ticking = false;
    function updateHeader() {
      var scrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      if (scrollY > 20) {
        headerContainer.classList.add('is-scrolled');
        document.body.classList.add('is-scrolled');
      } else {
        headerContainer.classList.remove('is-scrolled');
        document.body.classList.remove('is-scrolled');
      }
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(updateHeader);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    window.addEventListener('orientationchange', onScroll, { passive: true });
    updateHeader();
  }

  function setupRitualMobileScroll(root) {
    root.querySelectorAll('[data-section-type="pt-rituale-home"]').forEach(function (section) {
      var carousel = section.querySelector('.pt-rituale-home__mobile');
      var control = section.querySelector('[data-pt-rituale-scrollbar]');
      var frame;
      if (!carousel || !control || control.hasAttribute('data-pt-scroll-ready')) return;

      control.setAttribute('data-pt-scroll-ready', '');

      function updateControl() {
        frame = null;
        var maxScroll = Math.max(0, carousel.scrollWidth - carousel.clientWidth);
        var progress = maxScroll ? carousel.scrollLeft / maxScroll : 0;
        var visibleRatio = carousel.scrollWidth ? carousel.clientWidth / carousel.scrollWidth : 1;
        var itemCount = carousel.querySelectorAll('.pt-rituale-home__mobile-item').length;
        var activeItem = itemCount > 1 ? Math.round(progress * (itemCount - 1)) + 1 : 1;

        control.value = Math.max(0, Math.min(100, progress * 100));
        control.style.setProperty('--pt-scroll-thumb', Math.max(44, control.clientWidth * visibleRatio) + 'px');
        control.setAttribute('aria-valuetext', 'Passaggio ' + activeItem + ' di ' + itemCount);
        control.disabled = maxScroll === 0;
      }

      function requestUpdate() {
        if (frame) return;
        frame = window.requestAnimationFrame(updateControl);
      }

      carousel.addEventListener('scroll', requestUpdate, { passive: true });
      control.addEventListener('input', function () {
        var maxScroll = Math.max(0, carousel.scrollWidth - carousel.clientWidth);
        carousel.scrollLeft = maxScroll * (parseFloat(control.value) / 100);
      });

      if ('ResizeObserver' in window) {
        new ResizeObserver(requestUpdate).observe(carousel);
      } else {
        window.addEventListener('resize', requestUpdate);
      }

      window.requestAnimationFrame(updateControl);
    });
  }

  function setupRitualGestureDetails(root) {
    var cards = (root || document).querySelectorAll('.pt-rituale-home__mobile-card');
    cards.forEach(function (card) {
      if (card.hasAttribute('data-pt-gesto-ready')) return;
      card.setAttribute('data-pt-gesto-ready', '');

      var media = card.querySelector('.pt-rituale-home__mobile-media');
      var panel = card.querySelector('.pt-rituale-home__mobile-spiegazione');
      var details = card.querySelector('.pt-rituale-home__mobile-approfondimento');
      var summary = details ? details.querySelector('summary') : null;
      var closeBtn = panel ? panel.querySelector('.pt-rituale-home__mobile-spiegazione-close') : null;
      // badge removed
      if (!panel) return;

      var animTimer = null;

      function openPanel() {
        if (panel.classList.contains('is-open') && !panel.classList.contains('is-closing')) return;

        var carousel = card.closest('.pt-rituale-home__mobile');
        if (carousel) {
          carousel.querySelectorAll('.pt-rituale-home__mobile-card').forEach(function (otherCard) {
            if (otherCard !== card) {
              var otherPanel = otherCard.querySelector('.pt-rituale-home__mobile-spiegazione.is-open');
              if (otherPanel) {
                var otherClose = otherCard.querySelector('.pt-rituale-home__mobile-spiegazione-close');
                if (otherClose) {
                  otherClose.click();
                } else {
                  otherPanel.classList.remove('is-open');
                }
              }
            }
          });
        }

        clearTimeout(animTimer);
        panel.classList.remove('is-closing');
        card.classList.add('is-open');
        card.classList.remove('is-closing');
        if (details) {
          details.setAttribute('open', '');
          details.classList.add('is-open');
          details.classList.remove('is-closing');
        }

        void panel.offsetHeight;
        panel.classList.add('is-open');

        animTimer = setTimeout(function () {
          animTimer = null;
        }, 360);
      }

      function closePanel() {
        if (!panel.classList.contains('is-open') || panel.classList.contains('is-closing')) return;

        clearTimeout(animTimer);
        panel.classList.remove('is-open');
        panel.classList.add('is-closing');
        card.classList.remove('is-open');
        card.classList.add('is-closing');
        if (details) {
          details.classList.remove('is-open');
          details.classList.add('is-closing');
        }

        animTimer = setTimeout(function () {
          panel.classList.remove('is-closing');
          card.classList.remove('is-closing');
          if (details) {
            details.removeAttribute('open');
            details.classList.remove('is-closing');
          }
          animTimer = null;
        }, 240);
      }

      function toggle() {
        if (panel.classList.contains('is-open')) {
          closePanel();
        } else {
          openPanel();
        }
      }

      if (summary) {
        summary.addEventListener('click', function (e) {
          e.preventDefault();
          toggle();
        });
      }



      if (media) {
        media.addEventListener('click', function (e) {
          if (e.target.closest('.pt-rituale-home__mobile-spiegazione')) return;
          toggle();
        });
      }

      if (closeBtn) {
        closeBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          closePanel();
        });
      }

      panel.addEventListener('click', function (e) {
        if (e.target.closest('a') || e.target.closest('button')) return;
        closePanel();
      });
    });
  }

  function setupPensaTabs(root) {
    root.querySelectorAll('[data-pt-pensa]:not([data-pt-pensa-ready])').forEach(function (widget) {
      var tabs = Array.prototype.slice.call(widget.querySelectorAll('[data-pt-pensa-tab]'));
      var panels = Array.prototype.slice.call(widget.querySelectorAll('[data-pt-pensa-panel]'));
      if (!tabs.length || !panels.length) return;

      widget.setAttribute('data-pt-pensa-ready', '');

      function activate(tab, moveFocus) {
        var targetId = tab.getAttribute('data-pt-pensa-target');

        tabs.forEach(function (item) {
          var active = item === tab;
          item.setAttribute('aria-selected', active ? 'true' : 'false');
          item.classList.toggle('is-active', active);
          item.tabIndex = active ? 0 : -1;
        });

        panels.forEach(function (panel) {
          var active = panel.id === targetId;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });

        if (moveFocus) tab.focus();
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          activate(tab, false);
        });

        tab.addEventListener('keydown', function (event) {
          var nextIndex = index;

          if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
            nextIndex = (index + 1) % tabs.length;
          } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
            nextIndex = (index - 1 + tabs.length) % tabs.length;
          } else if (event.key === 'Home') {
            nextIndex = 0;
          } else if (event.key === 'End') {
            nextIndex = tabs.length - 1;
          } else {
            return;
          }

          event.preventDefault();
          activate(tabs[nextIndex], true);
        });
      });
    });
  }

  function setupPensaMobile(root) {
    root.querySelectorAll('[data-pt-pensa-mobile]:not([data-pt-pensa-mobile-ready])').forEach(function (widget) {
      var carousel = widget.querySelector('[data-pt-pensa-carousel]');
      var dots = Array.prototype.slice.call(widget.querySelectorAll('.pt-come-pensa__mobile-dot'));
      if (!carousel || !dots.length) return;

      widget.setAttribute('data-pt-pensa-mobile-ready', '');

      function updateDots() {
        var scrollLeft = carousel.scrollLeft;
        var maxScroll = carousel.scrollWidth - carousel.clientWidth;
        if (maxScroll <= 0) return;
        var card = carousel.querySelector('.pt-come-pensa__mobile-card');
        var cardWidth = card ? card.offsetWidth + 16 : 1;
        var activeIndex = Math.round(scrollLeft / cardWidth);
        activeIndex = Math.max(0, Math.min(dots.length - 1, activeIndex));

        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === activeIndex);
        });
      }

      carousel.addEventListener('scroll', updateDots, { passive: true });
    });
  }


  function setupAeScroll(root) {
    root.querySelectorAll('[data-pt-ae-scroll]:not([data-pt-ae-ready])').forEach(function (widget) {
      var viewport = widget.querySelector('[data-pt-ae-viewport]');
      var items = Array.prototype.slice.call(widget.querySelectorAll('[data-pt-ae-item]'));
      var cards = Array.prototype.slice.call(widget.querySelectorAll('[data-pt-ae-card]'));
      var panels = Array.prototype.slice.call(widget.querySelectorAll('[data-pt-ae-panel]'));
      var traitsList = widget.querySelector('[data-pt-ae-traits-list]');
      var traitItems = traitsList ? Array.prototype.slice.call(traitsList.querySelectorAll('[data-pt-trait]')) : [];
      var previous = widget.querySelector('[data-pt-ae-prev]');
      var next = widget.querySelector('[data-pt-ae-next]');
      var status = widget.querySelector('[data-pt-ae-status]');
      var family = widget.closest('.pt-famiglie-shop-v2__famiglia');
      var stateKey = family && family.id ? family.id : '';
      var initialIndex = parseInt(widget.getAttribute('data-pt-ae-initial'), 10);
      var restoringState = false;
      var activeIndex;
      var frame;
      var programmaticScroll = false;
      var scrollTimer;

      if (!viewport || !items.length || cards.length !== items.length) return;

      widget.setAttribute('data-pt-ae-ready', '');
      initialIndex = isNaN(initialIndex) ? 0 : initialIndex;
      if (stateKey && window.history.state && window.history.state.ptAeIndexes) {
        var savedIndex = parseInt(window.history.state.ptAeIndexes[stateKey], 10);
        if (!isNaN(savedIndex)) {
          initialIndex = savedIndex;
          restoringState = true;
          widget.classList.add('is-restoring', 'is-visible');
        }
      }
      initialIndex = Math.max(0, Math.min(items.length - 1, initialIndex));
      activeIndex = initialIndex;

      function rememberActiveIndex(index) {
        if (!stateKey) return;
        try {
          var currentState = window.history.state && typeof window.history.state === 'object'
            ? window.history.state
            : {};
          var nextState = Object.assign({}, currentState);
          nextState.ptAeIndexes = Object.assign({}, currentState.ptAeIndexes || {});
          nextState.ptAeIndexes[stateKey] = index;
          window.history.replaceState(nextState, '', window.location.href);
        } catch (error) {}
      }

      function finishProgrammaticScroll() {
        programmaticScroll = false;
        widget.classList.remove('is-scrolling');
        scrollTimer = null;
      }

      function updateTraits(panel) {
        if (!traitItems.length || !panel) return;
        var traitsRaw = panel.getAttribute('data-pt-ae-traits') || '';
        var activeTraits = traitsRaw.split(',').map(function (t) { return t.trim(); }).filter(Boolean);

        traitItems.forEach(function (traitEl) {
          var traitKey = traitEl.getAttribute('data-pt-trait');
          var isActive = activeTraits.indexOf(traitKey) !== -1;
          traitEl.classList.toggle('is-active', isActive);
        });
      }

      function centerItem(index, animate) {
        var item = items[index];
        var left = item.offsetLeft - (viewport.clientWidth - item.offsetWidth) / 2;
        var behavior = animate && !reducedMotion.matches ? 'smooth' : 'auto';

        programmaticScroll = true;
        if (behavior === 'smooth') {
          widget.classList.add('is-scrolling');
        }
        window.clearTimeout(scrollTimer);

        try {
          viewport.scrollTo({ left: left, behavior: behavior });
        } catch (error) {
          viewport.scrollLeft = left;
        }

        scrollTimer = window.setTimeout(finishProgrammaticScroll, behavior === 'smooth' ? 580 : 0);
      }

      function activate(index, options) {
        options = options || {};
        index = Math.max(0, Math.min(items.length - 1, index));
        activeIndex = index;
        rememberActiveIndex(index);

        items.forEach(function (item, itemIndex) {
          item.classList.toggle('is-active', itemIndex === index);
        });

        cards.forEach(function (card, cardIndex) {
          var active = cardIndex === index;
          card.setAttribute('aria-pressed', active ? 'true' : 'false');
          card.tabIndex = active ? 0 : -1;
        });

        panels.forEach(function (panel, panelIndex) {
          var active = panelIndex === index;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
          if (active) {
            updateTraits(panel);
          }
        });

        if (previous) previous.disabled = index === 0;
        if (next) next.disabled = index === items.length - 1;

        if (status) {
          status.textContent = cards[index].getAttribute('data-pt-ae-label') + ', prodotto ' + (index + 1) + ' di ' + items.length;
        }

        if (options.focus) cards[index].focus();
        if (options.center) centerItem(index, options.animate !== false);
      }

      function updateFromScroll() {
        frame = null;
        if (programmaticScroll) return;

        var viewportCenter = viewport.scrollLeft + viewport.clientWidth / 2;
        var closestIndex = 0;
        var closestDistance = Infinity;

        items.forEach(function (item, index) {
          var itemCenter = item.offsetLeft + item.offsetWidth / 2;
          var distance = Math.abs(itemCenter - viewportCenter);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        if (closestIndex !== activeIndex) activate(closestIndex);
      }

      function requestScrollUpdate() {
        if (programmaticScroll || frame) return;
        frame = window.requestAnimationFrame(updateFromScroll);
      }

      cards.forEach(function (card, index) {
        card.addEventListener('mousedown', function (e) {
          if (index !== activeIndex) {
            e.preventDefault();
          }
        });
        card.addEventListener('click', function () {
          if (index === activeIndex) {
            var productUrl = card.getAttribute('data-pt-ae-url');
            if (productUrl) {
              window.location.href = productUrl;
            }
          } else {
            card.blur();
            widget.classList.add('is-scrolling');
            activate(index, { center: true });
          }
        });

        card.addEventListener('keydown', function (event) {
          var targetIndex = index;

          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
            targetIndex = index + 1;
          } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
            targetIndex = index - 1;
          } else if (event.key === 'Home') {
            targetIndex = 0;
          } else if (event.key === 'End') {
            targetIndex = items.length - 1;
          } else {
            return;
          }

          event.preventDefault();
          activate(targetIndex, { center: true, focus: true });
        });
      });

      widget.addEventListener('keydown', function (event) {
        if (event.target && (event.target.matches('input, textarea, select') || event.target.matches('[data-pt-ae-card]'))) {
          return;
        }

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          if (activeIndex < items.length - 1) {
            event.preventDefault();
            activate(activeIndex + 1, { center: true, focus: false });
          }
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          if (activeIndex > 0) {
            event.preventDefault();
            activate(activeIndex - 1, { center: true, focus: false });
          }
        } else if (event.key === 'Home') {
          event.preventDefault();
          activate(0, { center: true, focus: false });
        } else if (event.key === 'End') {
          event.preventDefault();
          activate(items.length - 1, { center: true, focus: false });
        }
      });

      if (previous) {
        previous.addEventListener('mousedown', function (e) {
          e.preventDefault();
        });
        previous.addEventListener('click', function (e) {
          e.preventDefault();
          activate(activeIndex - 1, { center: true, focus: false });
        });
      }
      if (next) {
        next.addEventListener('mousedown', function (e) {
          e.preventDefault();
        });
        next.addEventListener('click', function (e) {
          e.preventDefault();
          activate(activeIndex + 1, { center: true, focus: false });
        });
      }

      var userScrollTimeout;
      viewport.addEventListener('scroll', function () {
        if (!programmaticScroll) {
          widget.classList.add('is-scrolling');
          window.clearTimeout(userScrollTimeout);
          userScrollTimeout = window.setTimeout(function () {
            widget.classList.remove('is-scrolling');
          }, 150);
        }
        requestScrollUpdate();
      }, { passive: true });
      viewport.addEventListener('pointerdown', function () {
        programmaticScroll = false;
        window.clearTimeout(scrollTimer);
      }, { passive: true });

      if ('ResizeObserver' in window) {
        new ResizeObserver(function () {
          centerItem(activeIndex, false);
        }).observe(viewport);
      }

      window.requestAnimationFrame(function () {
        activate(initialIndex, { center: true, animate: false });
        widget.setAttribute('data-pt-ae-rendered', '');
        if (restoringState) {
          window.requestAnimationFrame(function () {
            widget.classList.remove('is-restoring');
          });
        }
      });
    });
  }

  function setupPrioritaExplorer(root) {
    root.querySelectorAll('[data-pt-priorita]:not([data-pt-priorita-ready])').forEach(function (widget) {
      var tablist = widget.querySelector('.pt-priorita-shop__tabs');
      var tabs = Array.prototype.slice.call(widget.querySelectorAll('[data-pt-priorita-tab]'));
      var panels = Array.prototype.slice.call(widget.querySelectorAll('[data-pt-priorita-panel]'));
      var status = widget.querySelector('[data-pt-priorita-status]');
      if (!tablist || !tabs.length || !panels.length) return;

      widget.setAttribute('data-pt-priorita-ready', '');

      function centerTab(tab) {
        if (tablist.scrollWidth <= tablist.clientWidth) return;
        var left = tab.offsetLeft - (tablist.clientWidth - tab.offsetWidth) / 2;

        try {
          tablist.scrollTo({
            left: Math.max(0, left),
            behavior: reducedMotion.matches ? 'auto' : 'smooth'
          });
        } catch (error) {
          tablist.scrollLeft = Math.max(0, left);
        }
      }

      function activate(tab, options) {
        options = options || {};
        var targetId = tab.getAttribute('data-pt-priorita-target');

        tabs.forEach(function (item) {
          var active = item === tab;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
          item.tabIndex = active ? 0 : -1;
        });

        panels.forEach(function (panel) {
          var active = panel.id === targetId;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });

        if (status) {
          var title = tab.querySelector('.pt-priorita-shop__tab-copy strong');
          status.textContent = title ? 'Priorità selezionata: ' + title.textContent : '';
        }

        if (options.focus) tab.focus();
        if (options.center !== false) centerTab(tab);
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          activate(tab);
        });

        tab.addEventListener('keydown', function (event) {
          var nextIndex = index;

          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
            nextIndex = (index + 1) % tabs.length;
          } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
            nextIndex = (index - 1 + tabs.length) % tabs.length;
          } else if (event.key === 'Home') {
            nextIndex = 0;
          } else if (event.key === 'End') {
            nextIndex = tabs.length - 1;
          } else {
            return;
          }

          event.preventDefault();
          activate(tabs[nextIndex], { focus: true });
        });
      });

      var initialTab = widget.querySelector('[data-pt-priorita-tab][aria-selected="true"]') || tabs[0];
      activate(initialTab, { center: false });
    });
  }

  function setupShopAjax(root) {
    var nav = root.querySelector('.pt-shop-header, .pt-shop-nav') || document.querySelector('.pt-shop-header, .pt-shop-nav');
    var grid = document.querySelector('.collection__content, #collection-main, .collection');
    if (!nav || !grid || nav.hasAttribute('data-pt-ajax-ready')) return;

    nav.setAttribute('data-pt-ajax-ready', '');

    var isFetching = false;
    var parser = new DOMParser();

    function loadCollection(url, pushState) {
      if (isFetching) return;
      isFetching = true;

      var currentGrid = document.querySelector('.collection__content, #collection-main, .collection');
      if (currentGrid) {
        currentGrid.style.transition = 'opacity 180ms ease';
        currentGrid.style.opacity = '0.35';
        currentGrid.style.pointerEvents = 'none';
      }

      var targetUrl = new URL(url, window.location.origin);
      var currentUrl = new URL(window.location.href);
      if (currentUrl.searchParams.has('preview_theme_id')) {
        targetUrl.searchParams.set('preview_theme_id', currentUrl.searchParams.get('preview_theme_id'));
      }

      fetch(targetUrl.toString())
        .then(function (response) {
          if (!response.ok) throw new Error('Network response was not ok');
          return response.text();
        })
        .then(function (html) {
          var doc = parser.parseFromString(html, 'text/html');

          if (doc.title) {
            document.title = doc.title;
          }

          var newHeader = doc.querySelector('.pt-shop-header, .pt-shop-nav');
          var currentHeader = document.querySelector('.pt-shop-header, .pt-shop-nav');
          if (newHeader && currentHeader) {
            currentHeader.innerHTML = newHeader.innerHTML;
            bindNavLinks(currentHeader);
          }

          var newContent = doc.querySelector('.collection__content, #collection-main, .collection');
          var activeGrid = document.querySelector('.collection__content, #collection-main, .collection');
          if (newContent && activeGrid) {
            activeGrid.innerHTML = newContent.innerHTML;
            activeGrid.className = newContent.className;
          }

          if (pushState !== false) {
            window.history.pushState({ url: url }, '', targetUrl.toString());
          }

          if (activeGrid) {
            activeGrid.style.opacity = '1';
            activeGrid.style.pointerEvents = '';
          }

          reveal(document);
          isFetching = false;
        })
        .catch(function (err) {
          console.error('[Petricore] AJAX load error, fallback:', err);
          isFetching = false;
          window.location.href = url;
        });
    }

    function bindNavLinks(container) {
      container.querySelectorAll('.pt-shop-header__link, .pt-shop-header__link-method, .pt-shop-nav__link').forEach(function (link) {
        link.addEventListener('click', function (event) {
          var href = link.getAttribute('href');
          if (!href || href.startsWith('#') || href.startsWith('javascript:')) return;
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

          event.preventDefault();

          var menu = link.closest('ul');
          if (menu) {
            menu.querySelectorAll('a').forEach(function (l) {
              l.classList.remove('is-active');
            });
            link.classList.add('is-active');
          }

          loadCollection(href, true);
        });
      });
    }

    bindNavLinks(nav);

    if (!window.ptShopPopstateBound) {
      window.ptShopPopstateBound = true;
      window.addEventListener('popstate', function (event) {
        if (event.state && event.state.url) {
          loadCollection(event.state.url, false);
        } else {
          loadCollection(window.location.pathname + window.location.search, false);
        }
      });
    }
  }

  function setupMetodoRipple(root) {
    if (reducedMotion.matches || window.innerWidth <= 768 || (window.matchMedia && (!window.matchMedia('(hover: hover)').matches || !window.matchMedia('(min-width: 48.01em)').matches))) return;

    var columns = (root || document).querySelectorAll(".pt-metodo__colonna");
    if (!columns.length) return;

    columns.forEach(function (col, idx) {
      var colIndex = idx + 1;
      var disp = document.getElementById("pt-water-disp-" + colIndex);
      var turb = document.getElementById("pt-water-turb-" + colIndex);
      if (!disp || !turb) return;

      var isHovered = false;
      var animFrame = null;
      var startTime = null;
      var currentScale = 0;

      function renderLoop(timestamp) {
        if (!startTime) startTime = timestamp;
        var t = (timestamp - startTime) / 1000;

        if (isHovered) {
          // Continuous organic water ripple wave
          var wave = Math.sin(t * 2.6) * 5.0 + Math.cos(t * 3.8) * 2.5 + 8.5;
          currentScale += (wave - currentScale) * 0.14;

          var freqX = 0.013 + Math.sin(t * 1.6) * 0.005;
          var freqY = 0.028 + Math.cos(t * 1.3) * 0.007;

          disp.setAttribute("scale", currentScale.toFixed(2));
          turb.setAttribute("baseFrequency", freqX.toFixed(4) + " " + freqY.toFixed(4));

          animFrame = requestAnimationFrame(renderLoop);
        } else {
          // Smooth return to still, calm water
          currentScale += (0 - currentScale) * 0.15;
          if (currentScale > 0.1) {
            disp.setAttribute("scale", currentScale.toFixed(2));
            animFrame = requestAnimationFrame(renderLoop);
          } else {
            disp.setAttribute("scale", "0");
            turb.setAttribute("baseFrequency", "0.015 0.030");
            animFrame = null;
            startTime = null;
          }
        }
      }

      function onEnter() {
        isHovered = true;
        if (!animFrame) {
          startTime = null;
          animFrame = requestAnimationFrame(renderLoop);
        }
      }

      function onLeave() {
        isHovered = false;
      }

      col.addEventListener("mouseenter", onEnter);
      col.addEventListener("focus", onEnter);
      col.addEventListener("mouseleave", onLeave);
      col.addEventListener("blur", onLeave);
    });
  }

  function setupMethodNavigator(root) {
    root.querySelectorAll("[data-pt-method]:not([data-pt-method-ready])").forEach(function (widget) {
      var tabs = Array.prototype.slice.call(widget.querySelectorAll("[data-pt-method-tab]"));
      var panels = Array.prototype.slice.call(widget.querySelectorAll("[data-pt-method-panel]"));
      if (!tabs.length || !panels.length) return;

      widget.setAttribute("data-pt-method-ready", "");

      function activate(tab, moveFocus) {
        var targetId = tab.getAttribute("data-pt-method-target");

        tabs.forEach(function (item) {
          var active = item === tab;
          item.setAttribute("aria-selected", active ? "true" : "false");
          item.classList.toggle("is-active", active);
          item.tabIndex = active ? 0 : -1;
        });

        panels.forEach(function (panel) {
          var active = panel.id === targetId;
          panel.hidden = !active;
          panel.classList.toggle("is-active", active);
        });

        if (moveFocus) tab.focus();
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener("click", function () {
          activate(tab, false);
        });

        tab.addEventListener("keydown", function (event) {
          var nextIndex = index;
          if (event.key === "ArrowRight" || event.key === "ArrowDown") {
            nextIndex = (index + 1) % tabs.length;
          } else if (event.key === "ArrowLeft" || event.key === "ArrowUp") {
            nextIndex = (index - 1 + tabs.length) % tabs.length;
          } else if (event.key === "Home") {
            nextIndex = 0;
          } else if (event.key === "End") {
            nextIndex = tabs.length - 1;
          } else {
            return;
          }
          event.preventDefault();
          activate(tabs[nextIndex], true);
        });
      });

      // Sub-selettore livelli (Essential, Complete, Intense) in ciascun pannello
      panels.forEach(function (panel) {
        var levelTabs = Array.prototype.slice.call(panel.querySelectorAll("[data-pt-level-tab]"));
        var levelPanels = Array.prototype.slice.call(panel.querySelectorAll("[data-pt-level-panel]"));
        if (!levelTabs.length || !levelPanels.length) return;

        function activateLevel(tab, moveFocus) {
          var targetId = tab.getAttribute("data-pt-level-target");

          levelTabs.forEach(function (item) {
            var active = item === tab;
            item.setAttribute("aria-selected", active ? "true" : "false");
            item.classList.toggle("is-active", active);
            item.tabIndex = active ? 0 : -1;
          });

          levelPanels.forEach(function (lp) {
            var active = lp.id === targetId;
            lp.hidden = !active;
            lp.classList.toggle("is-active", active);
          });

          if (moveFocus) tab.focus();
        }

        levelTabs.forEach(function (tab, lIndex) {
          tab.addEventListener("click", function () {
            activateLevel(tab, false);
          });

          tab.addEventListener("keydown", function (event) {
            var nextIndex = lIndex;
            if (event.key === "ArrowRight" || event.key === "ArrowDown") {
              nextIndex = (lIndex + 1) % levelTabs.length;
            } else if (event.key === "ArrowLeft" || event.key === "ArrowUp") {
              nextIndex = (lIndex - 1 + levelTabs.length) % levelTabs.length;
            } else if (event.key === "Home") {
              nextIndex = 0;
            } else if (event.key === "End") {
              nextIndex = levelTabs.length - 1;
            } else {
              return;
            }
            event.preventDefault();
            activateLevel(levelTabs[nextIndex], true);
          });
        });
      });

      var lastDialogTrigger = null;

      widget.querySelectorAll("[data-pt-path-dialog-open]").forEach(function (trigger) {
        trigger.addEventListener("click", function () {
          var dialogId = trigger.getAttribute("data-pt-path-dialog-open");
          var dialog = dialogId ? document.getElementById(dialogId) : null;
          if (!dialog) return;

          lastDialogTrigger = trigger;
          if (typeof dialog.showModal === "function") {
            dialog.showModal();
          } else {
            dialog.setAttribute("open", "");
          }
        });
      });

      widget.querySelectorAll("[data-pt-path-dialog]").forEach(function (dialog) {
        var closeButton = dialog.querySelector("[data-pt-path-dialog-close]");

        function closeDialog() {
          if (typeof dialog.close === "function") {
            dialog.close();
          } else {
            dialog.removeAttribute("open");
          }
        }

        if (closeButton) closeButton.addEventListener("click", closeDialog);

        dialog.addEventListener("click", function (event) {
          if (event.target === dialog) closeDialog();
        });

        dialog.addEventListener("close", function () {
          if (lastDialogTrigger) lastDialogTrigger.focus();
        });
      });
    });
  }


  function setupStickyPrioritaAnchor(root) {
    var desktopAnchor = document.querySelector('.header__icon--priorita');
    var mobileStrip = document.getElementById('ptHeaderPrioritaMobileStrip');
    var target = document.getElementById('sh-priorita');

    if (!target) {
      if (desktopAnchor) desktopAnchor.classList.remove('is-visible');
      if (mobileStrip) mobileStrip.classList.remove('is-visible');
      return;
    }

    var hero = document.querySelector('.pt-shop-hero');

    function updateVisibility() {
      var scrollY = window.pageYOffset || document.documentElement.scrollTop;
      var heroThreshold = hero ? (hero.offsetTop + hero.offsetHeight - 80) : 280;
      var targetRect = target.getBoundingClientRect();
      var isPastHero = scrollY > heroThreshold;
      var isBeforeTarget = targetRect.top > 140;
      var shouldShow = isPastHero && isBeforeTarget;

      if (desktopAnchor) {
        desktopAnchor.classList.toggle('is-visible', shouldShow);
      }
      if (mobileStrip) {
        mobileStrip.classList.toggle('is-visible', shouldShow);
      }
    }

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          updateVisibility();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });

    updateVisibility();
  }

  function init(root) {
    setupMetodoRipple(root || document);
    setupShopAjax(root || document);
    reveal(root || document);
    setupHero(root || document);
    setupPensaTabs(root || document);
    setupPensaMobile(root || document);
    setupAeScroll(root || document);
    setupPrioritaExplorer(root || document);
    setupRitualMobileScroll(root || document);
    setupRitualGestureDetails(root || document);
    setupMethodNavigator(root || document);
    setupStickyPrioritaAnchor(root || document);
    setupTransparentHeader();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var tab = event.target.matches && event.target.matches('[data-pt-pensa-tab]')
      ? event.target
      : event.target.querySelector && event.target.querySelector('[data-pt-pensa-tab]');

    if (tab) tab.click();

    var aeScroll = event.target.querySelector && event.target.querySelector('[data-pt-ae-scroll]');
    if (aeScroll) {
      var activeCard = aeScroll.querySelector('[data-pt-ae-card][aria-pressed="true"]');
      if (activeCard) activeCard.click();
    }

    var prioritaTab = event.target.matches && event.target.matches('[data-pt-priorita-tab]')
      ? event.target
      : event.target.querySelector && event.target.querySelector('[data-pt-priorita-tab]');

    if (prioritaTab) prioritaTab.click();

    var methodTab = event.target.matches && event.target.matches('[data-pt-method-tab]')
      ? event.target
      : event.target.querySelector && event.target.querySelector('[data-pt-method-tab]');

    if (methodTab) methodTab.click();
  });

  // Navigazione diretta al click sulle voci principali della navbar (es. Shop)
  document.addEventListener('click', function (event) {
    var parentLink = event.target.closest('.header-section .nav--depth-1 > .nav__item-parent > a.nav__link');
    if (parentLink) {
      var href = parentLink.getAttribute('href');
      if (href && href !== '#' && !href.startsWith('javascript:')) {
        window.location.href = href;
      }
    }

    // Scroll fluido verso la sezione Guida alla scelta se presente nella pagina
    var prioritaLink = event.target.closest('a[href*="#sh-priorita"]');
    if (prioritaLink) {
      var target = document.getElementById('sh-priorita');
      if (target) {
        event.preventDefault();
        var headerEl = document.querySelector('.header-container') || document.querySelector('.header');
        var headerHeight = headerEl ? headerEl.offsetHeight : 74;
        var targetPos = target.getBoundingClientRect().top + window.pageYOffset - headerHeight - 16;
        window.scrollTo({
          top: Math.max(0, targetPos),
          behavior: 'smooth'
        });
        if (window.history && window.history.pushState) {
          window.history.pushState(null, null, '#sh-priorita');
        }
      }
    }
  });

  // Gestione atterraggio diretto con hash #sh-priorita
  if (window.location.hash === '#sh-priorita') {
    window.addEventListener('load', function () {
      setTimeout(function () {
        var target = document.getElementById('sh-priorita');
        if (target) {
          var headerEl = document.querySelector('.header-container') || document.querySelector('.header');
          var headerHeight = headerEl ? headerEl.offsetHeight : 74;
          var targetPos = target.getBoundingClientRect().top + window.pageYOffset - headerHeight - 16;
          window.scrollTo({
            top: Math.max(0, targetPos),
            behavior: 'smooth'
          });
        }
      }, 150);
    });
  }

  reducedMotion.addEventListener('change', function () {
    init(document);
  });
})();
